import styled from 'styled-components'


export const MainContainer = styled.div`
    margin-top: 75px;
    #order-something{
        margin-top: 30vh;
        text-align: center;
        font-size: 30px;
        font-weight: 600;
    }
`